import type {
  OpeningHours,
  PhoneNumbers,
  SpecialOpeningHours,
} from '@/config/models';

import {useMemo} from 'react';

import {useConfig} from '@/modules/common/context/Config';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';
import {extractServiceCenterOpeningHours} from '@/modules/common/hooks/useServiceConfig/utils';

// @FIXME export in toolkit is missing
type ServiceConfig = {
  phone: PhoneNumbers;
  multiRoomBooking: PhoneNumbers;
  defaultOpeningHours: OpeningHours;
  specialOpeningHours: Array<SpecialOpeningHours>;
};

export const useServiceConfig = (): ServiceConfig => {
  const config = useConfig();
  const currentPage = useCurrentPage();
  const {phone, multiRoomBooking} = config.service[currentPage];

  return useMemo(() => {
    const serviceCenterOpeningHours = extractServiceCenterOpeningHours(
      config.configService
    );

    return {
      phone,
      multiRoomBooking,
      defaultOpeningHours:
        serviceCenterOpeningHours.defaultOpeningHours ??
        config.service.defaultOpeningHours,
      specialOpeningHours: serviceCenterOpeningHours.specialOpeningHours ?? [],
    };
  }, [
    config.configService,
    config.service.defaultOpeningHours,
    phone,
    multiRoomBooking,
  ]);
};
